// import React from "react";
// import { CustomLayout, CustomMain } from './styles'
// import Header from './Partials/header';
// import Footer from './Partials/Footer';
// import SubHeader from "./Partials/SubHeader";
// import { useSelector, useDispatch } from "react-redux";
// import { extendTheme, styled } from '@mui/material/styles';
// import DashboardIcon from '@mui/icons-material/Dashboard';
// import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
// import BarChartIcon from '@mui/icons-material/BarChart';
// import DescriptionIcon from '@mui/icons-material/Description';
// import LayersIcon from '@mui/icons-material/Layers';
// // import { AppProvider } from '@toolpad/core/AppProvider';
// // import { ReactRouterAppProvider } from '@toolpad/core/react-router';
// import { AppProvider } from '@toolpad/core/react-router-dom';
// import { DashboardLayout } from '@toolpad/core/DashboardLayout';
// import { PageContainer } from '@toolpad/core/PageContainer';
// import Grid from '@mui/material/Grid2';
// import { useLocation, useNavigate } from "react-router-dom";
// import TranslateIcon from '@mui/icons-material/Translate';
// import { Avatar, Chip, createTheme, Divider, Grid2, IconButton, ListItemButton, ListItemIcon, ListItemText, Menu, MenuItem, MenuList, Stack, TextField, Typography } from "@mui/material";
// import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
// import CustomMenu from "../CustomMenu";
// import SearchIcon from '@mui/icons-material/Search';
// import SearchOffIcon from '@mui/icons-material/SearchOff';
// import InputBase from '@mui/material/InputBase';
// import { alpha } from '@mui/material/styles';
// import SettingsIcon from '@mui/icons-material/Settings';
// import { changeApp } from "~/store/app/AppStore";
// import { changeUser } from "../../store/app/User";
// import { FormattedMessage } from "react-intl";
// import { useTheme } from '@mui/material/styles';
// // import { palette } from "../../Services/Providers/ThemeProvider";
// import SickIcon from '@mui/icons-material/Sick';
// import LocalHospitalIcon from '@mui/icons-material/LocalHospital';
// import MedicationLiquidIcon from '@mui/icons-material/MedicationLiquid';
// import { useIntl } from 'react-intl';
// import { Account, AccountPopoverFooter, AccountPreview, SignOutButton } from "@toolpad/core";
// import PropTypes from 'prop-types';
// import MoreVertIcon from '@mui/icons-material/MoreVert';
// import { initialProduct, setProducts } from "../../store/app/Product";
// import { initialCurrency } from "../../store/app/StaticData";
// // import HomeIco from '~/Assets/icons/الرئيسية.png'
// import HomeIco from '~/Assets/icons2/الرئيسية.svg'
// // import PosIco from '~/Assets/icons/نقطة البيع.png'
// import PosIco from '~/Assets/icons2/نقطة البيع.svg'
// // import RecIco from '~/Assets/icons/الايصالات.png'
// import RecIco from '~/Assets/icons2/الايصالات.svg'
// import RecIco1 from '~/Assets/icons2/products.svg'
// import AsIco from '~/Assets/icons2/file (1).svg'
// import As1Ico from '~/Assets/icons2/accounting (1).svg'
// // import ExIco from '~/Assets/icons/المواد الموجودة.png'
// import ExIco from '~/Assets/icons2/المواد الموجودة.svg'
// import PrIco from '~/Assets/icons2/ملف الصيدلية.svg'
// import Pr1Ico from '~/Assets/icons2/save-file.svg'
// // import PrIco from '~/Assets/icons2/ملف الصيدلية.svg'
// import WeIco from '~/Assets/icons2/مستودعات.svg'
// import checkoutIcon from '~/Assets/icons2/checkout.svg'
// import AcIco from '~/Assets/icons2/الحسايات.svg'
// import DeIco from '~/Assets/icons2/دليل الحسابات.svg'
// import CuIco from '~/Assets/icons2/الزبائن.svg'
// import SuIco from '~/Assets/icons2/الموردون.svg'
// import BiIco from '~/Assets/icons2/اضافة فاتورة.svg'
// import ReIco from '~/Assets/icons/المواد المطلوبة.png'
// import ExpIco from '~/Assets/icons2/مواد قريبة الانتهاء.svg'
// import ItemTrenIco from '~/Assets/icons2/حركة مادة.svg'
// import ProIco from '~/Assets/icons2/تقرير الربح.svg'
// import OpenIco from '~/Assets/icons/بضاعة اول مدة.png'
// import UsersIco from '~/Assets/icons/مستخدمين.png'
// import PrivateIco from '~/Assets/icons/مواد خاصة.png'
// import RepoIco from '~/Assets/icons/المخازن.png'
// import CurIco from '~/Assets/icons/العملات.png'
// import CurIco1 from '~/Assets/icons/الاتشراكات.png'
// import HomeRoundedIcon from '@mui/icons-material/HomeRounded';
// import { Notifications } from "@mui/icons-material";

// function useDemoRouter(initialPath, navigate) {
//   const [pathname, setPathname] = React.useState(initialPath);
//   const router = React.useMemo(() => {
//     return {
//       pathname,
//       searchParams: new URLSearchParams(),
//       navigate: (path) => setPathname(String(path)),
//     };
//   }, [pathname]);

//   // return navigate(pathname);
//   return router;
// }

// const Search = styled('div')(({ theme }) => ({
//   position: 'relative',
//   borderRadius: theme.shape.borderRadius,
//   backgroundColor: alpha(theme.palette.primary.main, 1),
//   color: theme.palette.secondary.main,
//   '&:hover': {
//     backgroundColor: alpha(theme.palette.primary.main, 0.25),
//   },
//   marginLeft: 0,
//   // width: '100%',
//   [theme.breakpoints.up('sm')]: {
//     marginLeft: theme.spacing(1),
//     width: 'auto',
//     // position: 'absolute', top: '105%', right: '15%'
//   },
//   [theme.breakpoints.down('550')]: {
//     position: 'absolute', top: '105%', right: '15%', width: '70%'
//   },
// }));

// const SearchIconWrapper = styled('div')(({ theme }) => ({
//   padding: theme.spacing(0, 2),
//   height: '100%',
//   position: 'absolute',
//   pointerEvents: 'none',
//   display: 'flex',
//   alignItems: 'center',
//   justifyContent: 'center',
// }));

// const StyledInputBase = styled(InputBase)(({ theme }) => ({
//   color: 'secondary',
//   width: '100%',
//   '& .MuiInputBase-input': {
//     padding: theme.spacing(1, 1, 1, 0),
//     // vertical padding + font size from searchIcon
//     paddingLeft: `calc(1em + ${theme.spacing(4)})`,
//     transition: theme.transitions.create('width'),
//     [theme.breakpoints.up('sm')]: {
//       width: '12ch',
//       '&:focus': {
//         width: '20ch',
//       },
//     },
//   },
// }));

// const Layout = ({ children }) => {
//   const app = useSelector((state) => state?.app?.app)
//   const user = useSelector((state) => state?.app?.user?.data)
//   const [open, setOpen] = React.useState(false);
//   const [openSearch, setOpenSearch] = React.useState(false);
//   const navigate = useNavigate();
//   const dispatch = useDispatch()
//   const theme = useTheme();
//   const intl = useIntl();
//   const location = useLocation();

//   const NAVIGATION = [
//     {
//       kind: 'header',
//       title: 'العناصر الرئيسية',
//     },
//     {
//       kind: 'page',
//       segment: 'home',
//       title: intl.formatMessage({ id: `header.homePage` }),
//       icon: <img src={HomeIco} style={{ width: '25px', marginRight: '-3px' }} />,
//       // icon: <HomeRoundedIcon />,
//     },
//     {
//       kind: 'page',
//       segment: 'home-page',
//       title: intl.formatMessage({ id: `header.pos` }),
//       icon: <img src={PosIco} style={{ width: '25px', marginRight: '-3px' }} />,
//     },
//     // {
//     //   kind: 'page',
//     //   segment: 'explore-all-medicines',
//     //   title: intl.formatMessage({ id: `header.explore-all-medicines` }),
//     //   icon: <img src={PosIco} style={{ width: '25px' }} />,
//     // },
//     {
//       kind: 'page',
//       segment: 'material-selection',
//       title: intl.formatMessage({ id: `header.materialSelection` }),
//       icon: <img src={ExIco} style={{ width: '25px', marginRight: '-3px' }} />,
//     },
//     {
//       kind: 'page',
//       segment: 'products-you-want-to-sell-online',
//       title: intl.formatMessage({ id: `header.ProductsYouWantToSellOnline` }),
//       icon: <img src={RecIco1} style={{ width: '25px', marginRight: '-3px' }} />,
//     },
//     {
//       kind: 'page',
//       segment: 'receipts',
//       title: intl.formatMessage({ id: `header.receipts` }),
//       icon: <img src={RecIco} style={{ width: '25px', marginRight: '-3px' }} />,
//     },
//     {
//       kind: 'page',
//       segment: 'pharmacy',
//       title: intl.formatMessage({ id: `header.pharmacy` }),
//       icon: <img src={PrIco} style={{ width: '25px', marginRight: '-3px' }} />,
//     },
//     {
//       kind: 'page',
//       segment: 'warehouses',
//       title: intl.formatMessage({ id: `header.warehouses` }),
//       icon: <img src={WeIco} style={{ width: '25px', marginRight: '-3px' }} />,
//     },
//     {
//       kind: 'page',
//       segment: 'warehouse-orders',
//       title: intl.formatMessage({ id: `header.warehouse-orders` }),
//       icon: <img src={checkoutIcon} style={{ width: '25px', marginRight: '-3px' }} />,
//     },
//     // {
//     //   kind: 'page',
//     //   segment: 'medicine',
//     //   title: intl.formatMessage({ id: `header.medicine` }),
//     //   icon: <SickIcon />,
//     // },
//     // {
//     //   kind: 'page',
//     //   segment: 'doctors',
//     //   title: intl.formatMessage({ id: `header.doctors` }),
//     //   icon: <LocalHospitalIcon />,
//     // },
//     {
//       kind: 'divider',
//     },
//     // {
//     //   kind: 'header',
//     //   title: 'Scheduling',
//     // },
//     {
//       segment: 'accounts',
//       title: intl.formatMessage({ id: `header.accounts` }),
//       icon: <img src={AcIco} style={{ width: '25px', marginRight: '-3px' }} />,
//       children: [
//         {
//           segment: 'acounts-directory',
//           title: intl.formatMessage({ id: `header.directoryAcounts` }),
//           icon: <img src={DeIco} style={{ width: '25px', marginRight: '-3px' }} />,
//           // action: <Chip val />,
//         },
//         {
//           segment: 'customer',
//           title: intl.formatMessage({ id: `header.customer` }),
//           icon: <img src={CuIco} style={{ width: '25px', marginRight: '-3px' }} />,
//           // action: <Chip val />,
//         },
//         {
//           segment: 'suppliers',
//           title: intl.formatMessage({ id: `header.suppliers` }),
//           icon: <img src={SuIco} style={{ width: '25px' }} />,
//         },
//         {
//           segment: 'detailed-account-statement',
//           title: intl.formatMessage({ id: `header.detailedAccountStatement` }),
//           icon: <img src={AsIco} style={{ width: '25px', marginRight: '-3px' }} />,
//         },
//         {
//           segment: 'total-account-statement',
//           title: intl.formatMessage({ id: `header.TotalAccountStatement` }),
//           icon: <img src={As1Ico} style={{ width: '25px', marginRight: '-3px' }} />,
//         },
//       ],
//     },
//     {
//       kind: 'divider',
//     },
//     {
//       kind: 'page',
//       segment: 'bills',
//       title: intl.formatMessage({ id: `header.bills` }),
//       icon: <img src={BiIco} style={{ width: '25px', marginRight: '-3px' }} />,
//     },
//     {
//       kind: 'page',
//       segment: 'bills/add-bill',
//       title: intl.formatMessage({ id: `header.addBills` }),
//       icon: <img src={BiIco} style={{ width: '25px', marginRight: '-3px' }} />,
//     },
//     {
//       kind: 'page',
//       segment: 'union-bills',
//       title: intl.formatMessage({ id: `header.unionBills` }),
//       icon: <img src={BiIco} style={{ width: '25px', marginRight: '-3px' }} />,
//     },
//     {
//       kind: 'page',
//       segment: 'accounting-transaction',
//       title: intl.formatMessage({ id: `header.AccountingTransaction` }),
//       icon: <img src={Pr1Ico} style={{ width: '25px', marginRight: '-3px' }} />,
//     },
//     {
//       kind: 'page',
//       segment: 'open-accounting-transaction',
//       title: intl.formatMessage({ id: `header.openAccountingTransaction` }),
//       icon: <img src={Pr1Ico} style={{ width: '25px', marginRight: '-3px' }} />,
//     },
//     {
//       kind: 'page',
//       segment: 'required-materials',
//       title: intl.formatMessage({ id: `header.RequiredMaterials` }),
//       icon: <img src={ExIco} style={{ width: '25px', marginRight: '-3px' }} />,
//     },
//     {
//       kind: 'page',
//       segment: 'closing-expire-date-item',
//       title: intl.formatMessage({ id: `header.ClosingExpireDateItem` }),
//       icon: <img src={ExpIco} style={{ width: '25px', marginRight: '-3px' }} />,
//     },
//     {
//       kind: 'page',
//       segment: 'items-transactions',
//       title: intl.formatMessage({ id: `header.ItemsTransactions` }),
//       icon: <img src={ItemTrenIco} style={{ width: '25px', marginRight: '-3px' }} />,
//     },
//     {
//       kind: 'page',
//       segment: 'material-inventory',
//       title: intl.formatMessage({ id: `header.MaterialInventory` }),
//       icon: <img src={PrIco} style={{ width: '25px', marginRight: '-3px' }} />,
//     },
//     {
//       kind: 'page',
//       segment: 'profit-report',
//       title: intl.formatMessage({ id: `header.ProfitReport` }),
//       icon: <img src={ProIco} style={{ width: '25px', marginRight: '-3px' }} />,
//     },
//     {
//       kind: 'page',
//       segment: 'openingm-erchandise',
//       title: intl.formatMessage({ id: `header.OpeningMerchandise` }),
//       icon: <img src={OpenIco} style={{ width: '25px', marginRight: '-3px' }} />,
//     },
//     {
//       kind: 'page',
//       segment: 'users',
//       title: intl.formatMessage({ id: `header.users` }),
//       icon: <img src={UsersIco} style={{ width: '25px', marginRight: '-3px' }} />,
//     },
//     {
//       kind: 'page',
//       segment: 'roles',
//       title: intl.formatMessage({ id: `header.Roles` }),
//       icon: <img src={PrIco} style={{ width: '25px', marginRight: '-3px' }} />,
//     },
//     {
//       kind: 'page',
//       segment: 'trial-balance',
//       title: intl.formatMessage({ id: `header.TrialBalance` }),
//       icon: <img src={PrIco} style={{ width: '25px', marginRight: '-3px' }} />,
//     },
//     {
//       kind: 'page',
//       segment: 'orders',
//       title: intl.formatMessage({ id: `header.Orders` }),
//       icon: <img src={PrIco} style={{ width: '25px', marginRight: '-3px' }} />,
//     },
//     {
//       kind: 'page',
//       segment: 'final-accounts',
//       title: intl.formatMessage({ id: `header.FinalAccounts` }),
//       icon: <img src={PrIco} style={{ width: '25px', marginRight: '-3px' }} />,
//     },
//     {
//       kind: 'page',
//       segment: 'special-materials',
//       title: intl.formatMessage({ id: `header.SpecialMaterials` }),
//       icon: <img src={PrivateIco} style={{ width: '25px', marginRight: '-3px' }} />,
//     },
//     {
//       kind: 'page',
//       segment: 'repository',
//       title: intl.formatMessage({ id: `header.repository` }),
//       icon: <img src={RepoIco} style={{ width: '25px', marginRight: '-3px' }} />,
//     },
//     {
//       kind: 'page',
//       segment: 'currency',
//       title: intl.formatMessage({ id: `header.currency` }),
//       icon: <img src={CurIco} style={{ width: '25px', marginRight: '-3px' }} />,
//     },
//     {
//       kind: 'page',
//       segment: 'subscription',
//       title: intl.formatMessage({ id: `header.subscription` }),
//       icon: <img src={CurIco1} style={{ width: '25px', marginRight: '-3px' }} />,
//     },
//     // {items-transactions
//     //   segment: 'integrations',
//     //   title: 'Integrations',
//     //   icon: <LayersIcon />,
//     // },
//     // {
//     //   kind: 'divider',
//     // },
//     // {
//     //   // segment: 'Change Lang',
//     //   title: 'Change Lang',
//     //   icon: <TranslateIcon />,
//     //   action: popoverMenuAction,
//     // },
//   ];

//   // const { window } = props;

//   const router = useDemoRouter('/home-page', navigate);

//   function toolbarActions() {
//     return (
//       <div className="flex justify-start gap-2 flex-wrap-reverse">
//         <SubHeader />
//         {/* <Search sx={{
//           display: !openSearch && "none",
//         }}>
//           <SearchIconWrapper>
//             <SearchIcon color="secondary" />
//           </SearchIconWrapper>
//           <StyledInputBase
//             placeholder="Search…"
//             inputProps={{ 'aria-label': 'search' }}
//           />
//         </Search>
//         <IconButton color="primary" onClick={() => setOpenSearch(prev => !prev)}>
//           <SearchIcon color="primary" sx={{ display: !!openSearch && "none" }} />
//           <SearchOffIcon color="primary" sx={{ display: !openSearch && "none" }} />
//         </IconButton>
//         <CustomMenu
//           menuItem={
//             [
//               {
//                 title: "Eng",
//                 menuOnClick: () => {
//                   dispatch(
//                     changeApp({ locale: "en", direction: "ltr" })
//                   )
//                 }
//               }, {
//                 title: "AR",
//                 menuOnClick: () => {
//                   dispatch(
//                     changeApp({ locale: "ar", direction: "rtl" })
//                   )
//                 }
//               }
//             ]
//           }
//           icon={<TranslateIcon color="primary" />} />
//         <CustomMenu
//           menuItem={
//             [
//               {
//                 title: <FormattedMessage id={"Profile"} />,
//                 menuOnClick: () => {
//                 }
//               }, {
//                 title: <FormattedMessage id={"logout"} />,
//                 menuOnClick: () => {
//                   dispatch(
//                     changeUser({
//                       data: {},
//                       roles: [],
//                       token: ""
//                     })
//                   )
//                 }
//               }
//             ]
//           }
//           icon={<SettingsIcon color="primary" />} /> */}
//       </div>
//     )
//   }

//   const palette = {
//     primary: { main: "#0094D9", dark: "#0094D9", light: "#77d4ff" },
//     secondary: { main: "#cce9f7", dark: "#02354d", light: "#cce9f7" },
//     pending: { main: "#f29339", dark: "#cce9f7", light: "#cce9f7" },
//     text: {
//       main: "#fff"
//     },
//     danger: { main: '#EB5757', dark: "#D90368", light: "#D90368" },
//   };

//   const customTheme = createTheme({
//     direction: app.direction,
//     // direction: "ltr",
//     locale: app.locale,
//     fontFamily: app.locale === 'en' ? 'Montserrat, sans-serif' : 'Cairo, sans-serif',
//     // fontFamily: 'Montserrat, sans-serif',
//     f_xs: '.6rem',
//     f_sm: '.8rem',
//     f_md: '1rem',
//     f_lg: '1.3rem',
//     f_xl: '1.6rem',
//     f_2xl: '1.8rem',
//     // breakpoints: {
//     //   keys: ["xs", "ss", "sm", "mm", "md", "lg", "xl"],
//     //   values: {
//     //     ss: 201,
//     //     xs: 426,
//     //     sm: 601,
//     //     md: 767,
//     //     lg: 900,
//     //     lg2: 1000,
//     //     xl: 1023,
//     //     xlDown: 1024,
//     //     x2l: 1249,
//     //     x3l: 1441,
//     //     x4l: 1700,
//     //     x5l: 1921
//     //   },
//     // },
//     typography: {
//       fontFamily: app.locale === 'en' ? 'Montserrat, sans-serif' : 'Cairo, sans-serif',
//     },
//     palette: {
//       type: app.theme,
//       ...palette,
//     },
//   });

//   // const navigationWithActions = NAVIGATION.map((item) => {
//   //   const isActive = location.pathname.includes(item.segment);

//   //   return {
//   //     ...item,
//   //     action: () => navigate(`/${item.segment}`),
//   //     // sx: isActive
//   //     // ? { backgroundColor: "red", color: "red", borderRadius: "8px", width: '10px' }
//   //     // : { backgroundColor: "red", color: "red", borderRadius: "8px", width: '10px' },
//   //     sx: {
//   //       "& .MuiListItem-root": {
//   //         backgroundColor: "red", color: "red", borderRadius: "8px", width: '10px'
//   //       }
//   //     },
//   //     style: {
//   //       backgroundColor: "red", color: "red", borderRadius: "8px", width: '10px'
//   //     }
//   //   };
//   // });

//   const accounts = [
//     {
//       id: 1,
//       name: 'Bharat Kashyap',
//       email: 'bharatkashyap@outlook.com',
//       image: 'https://avatars.githubusercontent.com/u/19550456',
//       projects: [
//         {
//           id: 3,
//           title: 'Project X',
//         },
//       ],
//     }
//   ];

//   function SidebarFooterAccountPopover() {
//     return (
//       <Stack direction="column">
//         <Divider />
//         {/* <Typography variant="body2" mx={2} mt={1}>
//           Accounts
//         </Typography> */}
//         <MenuList>
//           {/* {accounts.map((account) => ( */}
//           <MenuItem
//             key={user?.id}
//             component="button"
//             sx={{
//               justifyContent: 'flex-start',
//               width: '100%',
//               columnGap: 2,
//             }}
//           >
//             <ListItemIcon>
//               <Avatar
//                 sx={{
//                   width: 32,
//                   height: 32,
//                   fontSize: '0.95rem',
//                   bgcolor: "#0094D9",
//                 }}
//                 src={user?.image ?? ''}
//                 alt={user?.user_name ?? ''}
//               >
//                 {user?.user_name}
//               </Avatar>
//             </ListItemIcon>
//             <ListItemText
//               sx={{
//                 display: 'flex',
//                 flexDirection: 'column',
//                 alignItems: 'flex-start',
//                 width: '100%',
//               }}
//               primary={user?.user_name}
//               secondary={user?.name}
//               primaryTypographyProps={{ variant: 'body2' }}
//               secondaryTypographyProps={{ variant: 'caption' }}
//             />
//             {/* <ListItemButton> */}
//             {/* <IconButton color="primary" onClick={() => console.log("first")}> */}
//             <CustomMenu
//               menuItem={
//                 [
//                   {
//                     title: <FormattedMessage id={"Profile"} />,
//                     menuIcon: <Avatar />,
//                     menuOnClick: () => {
//                     }
//                   },
//                   {
//                     title: <FormattedMessage id={"logout"} />,
//                     menuOnClick: () => {
//                       localStorage.clear();
//                       dispatch(
//                         changeUser({
//                           data: {},
//                           roles: [],
//                           token: ""
//                         })
//                       )
//                       dispatch(
//                         initialProduct()
//                       )
//                       dispatch(
//                         initialCurrency()
//                       )
//                     }
//                   },
//                   {
//                     title: "Eng",
//                     menuOnClick: () => {
//                       dispatch(
//                         changeApp({ locale: "en", direction: "ltr" })
//                       )
//                     }
//                   }, {
//                     title: "AR",
//                     menuOnClick: () => {
//                       dispatch(
//                         changeApp({ locale: "ar", direction: "rtl" })
//                       )
//                     }
//                   }
//                 ]
//               }
//               icon={<MoreVertIcon color="primary" />} />
//             {/* </IconButton> */}
//             {/* </ListItemButton> */}
//           </MenuItem>
//           {/* // ))} */}
//         </MenuList>
//         {/* <AccountPopoverFooter>
//           <SignOutButton />
//         </AccountPopoverFooter> */}
//       </Stack>
//     );
//   }

//   const BRANDING = {
//     title: 'My Toolpad Core App',
//   };

//   return (
//     // <CustomLayout dir={app.direction}>
//     //   <Header />
//     //   <CustomMain open={open} dir={app.direction} className={`${app.locale === "ar" ? 'font-Cairo' : 'font-Montserrat'}`}>
//     //     <SubHeader />
//     //     {children}
//     //   </CustomMain>
//     //   <Footer />
//     // </CustomLayout>
//     <div dir={app.direction} style={{ fontFamily: theme.fontFamily, background: 'rgba(245, 245, 245, 1)', }}>
//       <AppProvider
//         navigation={NAVIGATION}
//         // navigation={navigationWithActions}
//         // router={router}
//         theme={customTheme}
//         // window={demoWindow}
//         branding={{
//           // logo: <img src="https://mui.com/static/logo.png" alt="MUI logo" />,
//           // logo: <h1>Cureox</h1>,
//           title: 'Cureox',
//           homeUrl: '/',
//         }}
//       >
//         {/* <ReactRouterAppProvider navigation={NAVIGATION} branding={BRANDING}> */}
//         <DashboardLayout
//           slots={{
//             toolbarActions: toolbarActions,
//             // toolbarAccount: () => null,
//             // sidebarFooter: SidebarFooterAccount
//             sidebarFooter: SidebarFooterAccountPopover
//             // sidebarFooter: AccountSidebarPreview
//           }}
//         // sx={{ background: 'red' }}
//         >
//           {/* <PageContainer> */}
//           <Grid2
//             sx={theme => ({
//               // [theme.breakpoints.down("")]
//               padding: '15px 15px',
//               [theme.breakpoints.down("md")]: {
//                 padding: '5px',
//               }
//               // background: 'rgba(245, 245, 245, 1)',
//               // minWidth: '100%',
//               // minHeight: '100%'
//             })}
//           >
//             {/* <SubHeader /> */}
//             {children}
//           </Grid2>
//           {/* <div className={`p-5`} style={{ fontFamily: `${theme.fontFamily}` }}>

//           </div> */}
//           {/* </PageContainer> */}
//         </DashboardLayout>
//       </AppProvider>
//       {/* </ReactRouterAppProvider> */}
//     </div>

//   );
// }


// // Layout.propTypes = {
// //   classes: PropTypes.object.isRequired,
// // };

// // decorate(Layout, {
// //   open: observable,
// // });

// // export default withMediaQuery("(max-width:1316px)")(withStyles(styles, { withTheme: true })(observer(Layout)));
// // export default observer(Layout);
// export default Layout;













import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { useIntl, FormattedMessage } from "react-intl";
import { useLocation, useNavigate } from "react-router-dom";
import {
  AppBar,
  Toolbar,
  Drawer,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Box,
  Stack,
  Typography,
  IconButton,
  Badge,
  Button,
  Chip,
  Divider,
  Collapse,
  Menu,
  MenuItem,
  Avatar,
  Paper,
  useMediaQuery,
  Autocomplete,
  TextField,
  Tooltip,
} from "@mui/material";
import { alpha, styled, useTheme } from "@mui/material/styles";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import NotificationsIcon from "@mui/icons-material/Notifications";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import TranslateIcon from "@mui/icons-material/Translate";
import SettingsIcon from "@mui/icons-material/Settings";
import LogoutIcon from "@mui/icons-material/Logout";
import HomeRoundedIcon from "@mui/icons-material/HomeRounded";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import SearchIcon from "@mui/icons-material/Search";
import PointOfSaleIcon from "@mui/icons-material/PointOfSale";
import InventoryIcon from "@mui/icons-material/Inventory";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import ReceiptIcon from "@mui/icons-material/Receipt";
import LocalPharmacyIcon from "@mui/icons-material/LocalPharmacy";
import WarehouseIcon from "@mui/icons-material/Warehouse";
import ShoppingBagIcon from "@mui/icons-material/ShoppingBag";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import ContactsIcon from "@mui/icons-material/Contacts";
import PeopleIcon from "@mui/icons-material/People";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import DescriptionIcon from "@mui/icons-material/Description";
import AssignmentIcon from "@mui/icons-material/Assignment";
import AssessmentIcon from "@mui/icons-material/Assessment";
import WarningIcon from "@mui/icons-material/Warning";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import Inventory2Icon from "@mui/icons-material/Inventory2";
import ZoomInIcon from "@mui/icons-material/ZoomIn";
import ZoomOutIcon from "@mui/icons-material/ZoomOut";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import UnarchiveIcon from "@mui/icons-material/Unarchive";
import PersonIcon from "@mui/icons-material/Person";
import SecurityIcon from "@mui/icons-material/Security";
import BalanceIcon from "@mui/icons-material/Balance";
import ListAltIcon from "@mui/icons-material/ListAlt";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import FolderSpecialIcon from "@mui/icons-material/FolderSpecial";
import StorageIcon from "@mui/icons-material/Storage";
import CurrencyExchangeIcon from "@mui/icons-material/CurrencyExchange";
import CardMembershipIcon from "@mui/icons-material/CardMembership";
import LocalHospitalIcon from "@mui/icons-material/LocalHospital";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import SubHeader from "./Partials/SubHeader";
import { changeApp } from "~/store/app/AppStore";
import { changeUser } from "../../store/app/User";
import { initialProduct } from "../../store/app/Product";
import { initialCurrency } from "../../store/app/StaticData";
import { UpperCaseFirst, userHavePermission } from "~/Services/Helpers";
import { CustomMain } from "./styles";
import { privateRoutes } from "../../Routes/RouteList";

const drawerWidth = 280;

const SearchWrapper = styled("form")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(1),
  borderRadius: 999,
  padding: theme.spacing(0.5, 1.25),
  backgroundColor: alpha(theme.palette.text.primary, 0.04),
  border: `1px solid ${alpha(theme.palette.text.primary, 0.08)}`,
  minWidth: 220,
  flex: 1,
  maxWidth: 360,
}));

const Layout = ({ children }) => {
  const app = useSelector((state) => state?.app?.app);
  const user = useSelector((state) => state?.app?.user?.data);
  // console.log('user', user)
  const isSalesman = user?.type === 1;
  const isDriver = user?.type === 2;
  const userRoles = useSelector((state) => state?.app?.user?.roles) || [];
  const isDistributer = user?.pharmacy?.is_distributor === true;
  const dispatch = useDispatch();
  const intl = useIntl();
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();
  const isMdUp = useMediaQuery(theme.breakpoints.up("md"));
  const [drawerOpen, setDrawerOpen] = React.useState(/* isMdUp */false);
  const [expandedGroups, setExpandedGroups] = React.useState({});
  const [searchValue, setSearchValue] = React.useState("");
  const [notifAnchorEl, setNotifAnchorEl] = React.useState(null);
  const [profileAnchorEl, setProfileAnchorEl] = React.useState(null);
  const [notifications, setNotifications] = React.useState([
    {
      id: "1",
      titleMessageId: "layout.notifications.newInvoiceTitle",
      bodyMessageId: "layout.notifications.newInvoiceBody",
      bodyValues: { number: "#254" },
      timeMessageId: "layout.notifications.time.justNow",
      read: false,
    },
    {
      id: "2",
      titleMessageId: "layout.notifications.stockAlertTitle",
      bodyMessageId: "layout.notifications.stockAlertBody",
      bodyValues: {
        medicineTranslations: {
          ar: "باراسيتامول",
          en: "Paracetamol",
        },
      },
      timeMessageId: "layout.notifications.time.tenMinutes",
      read: false,
    },
    {
      id: "3",
      titleMessageId: "layout.notifications.incomingPaymentTitle",
      bodyMessageId: "layout.notifications.incomingPaymentBody",
      bodyValues: { supplier: "ACME" },
      timeMessageId: "layout.notifications.time.today",
      read: true,
    },
  ]);

  const unreadCount = React.useMemo(() => notifications.filter((n) => !n.read).length, [notifications]);

  React.useEffect(() => {
    if (!isMdUp) {
      setDrawerOpen(false);
    }
  }, [isMdUp]);


  const handleDrawerToggle = () => {
    setDrawerOpen((prev) => !prev);
  };

  const handleToggleGroup = (segment) => {
    setExpandedGroups((prev) => ({ ...prev, [segment]: !prev[segment] }));
  };

  const handleLogout = () => {
    localStorage.clear();
    dispatch(
      changeUser({
        data: {},
        roles: [],
        token: "",
      })
    );
    dispatch(initialProduct());
    dispatch(initialCurrency());
    setProfileAnchorEl(null);
  };

  const handleLanguage = (locale, direction) => {
    dispatch(changeApp({ locale, direction }));
    setProfileAnchorEl(null);
  };

  const handleZoomIn = () => {
    const currentZoom = app.zoom || 100;
    const newZoom = Math.min(currentZoom + 10, 140); // الحد الأقصى 140%
    dispatch(changeApp({ zoom: newZoom }));
  };

  const handleZoomOut = () => {
    const currentZoom = app.zoom || 100;
    const newZoom = Math.max(currentZoom - 10, 70); // الحد الأدنى 70%
    dispatch(changeApp({ zoom: newZoom }));
  };

  // إنشاء خريطة تربط path بالصلاحيات من RouteList
  const routePermissionsMap = React.useMemo(() => {
    const map = new Map();
    privateRoutes.forEach((route) => {
      const path = route.path;
      const permissions = Array.isArray(route.permission) ? route.permission : [route.permission];
      map.set(path, permissions);
    });
    return map;
  }, []);

  // دالة للتحقق من صلاحية الوصول إلى segment
  const hasPermission = React.useCallback(
    (segment) => {
      const path = `/${segment}`;
      const permissions = routePermissionsMap.get(path);

      if (!permissions || permissions.length === 0) {
        return true; // إذا لم توجد صلاحيات محددة، السماح بالوصول
      }

      return userHavePermission(userRoles, permissions);
    },
    [userRoles, routePermissionsMap]
  );

  // دالة للتحقق من صلاحية مجموعة routes (للمسارات المتداخلة مثل accounts/customer)
  const hasPathPermission = React.useCallback(
    (segment) => {
      // تنظيف segment من الشرطة المائلة في البداية إن وجدت
      const cleanSegment = segment.startsWith("/") ? segment : `/${segment}`;

      // محاولة البحث بالمسار الكامل أولاً
      let permissions = routePermissionsMap.get(cleanSegment);

      if (permissions) {
        return userHavePermission(userRoles, permissions);
      }

      // البحث عن أي route يطابق المسار أو يبدأ به
      for (const [routePath, routePerms] of routePermissionsMap.entries()) {
        // مطابقة مباشرة
        if (routePath === cleanSegment) {
          return userHavePermission(userRoles, routePerms);
        }

        // إذا كان segment جزء من routePath (مثل accounts/customer في /accounts/customer)
        if (cleanSegment === routePath || routePath.startsWith(cleanSegment + "/")) {
          return userHavePermission(userRoles, routePerms);
        }

        // إذا كان routePath جزء من cleanSegment
        if (cleanSegment.startsWith(routePath + "/")) {
          return userHavePermission(userRoles, routePerms);
        }
      }

      return true; // إذا لم يُوجد route مطابق، السماح بالوصول (للمسارات الجديدة)
    },
    [userRoles, routePermissionsMap]
  );

  // navigation مع جميع العناصر قبل التصفية
  const allNavigation = React.useMemo(
    () => {
      const navItems = [
        // { kind: "header", title: "العناصر الرئيسية" },
        { kind: "page", segment: "home", title: intl.formatMessage({ id: `header.homePage` }), icon: <HomeRoundedIcon /> },
        { kind: "page", segment: "home-page", title: intl.formatMessage({ id: `header.pos` }), icon: <PointOfSaleIcon /> },
        { kind: "page", segment: "material-selection", title: intl.formatMessage({ id: `header.materialSelection` }), icon: <InventoryIcon /> },
        {
          kind: "page",
          segment: "products-you-want-to-sell-online",
          title: intl.formatMessage({ id: `header.ProductsYouWantToSellOnline` }),
          icon: <ShoppingCartIcon />,
        },
        { kind: "page", segment: "receipts", title: intl.formatMessage({ id: `header.receipts` }), icon: <ReceiptIcon /> },
        { kind: "page", segment: (isDistributer || isDriver || isSalesman) ? "orders-dist" : "orders", title: (isDistributer || isDriver || isSalesman) ? intl.formatMessage({ id: `header.OrdersDistributor` }) : intl.formatMessage({ id: `header.Orders` }), icon: <ListAltIcon /> },

        { kind: "page", segment: "pharmacy", title: intl.formatMessage({ id: `header.pharmacy` }), icon: <LocalPharmacyIcon /> },
        { kind: "divider" },
        {
          kind: "group",
          segment: "accounts",
          title: intl.formatMessage({ id: `header.accounts` }),
          icon: <AccountBalanceIcon />,
          children: [
            { segment: "accounts/acounts-directory", title: intl.formatMessage({ id: `header.directoryAcounts` }), icon: <ContactsIcon /> },
            { segment: "accounts/customer", title: intl.formatMessage({ id: `header.customer` }), icon: <PeopleIcon /> },
            { segment: "accounts/suppliers", title: intl.formatMessage({ id: `header.suppliers` }), icon: <LocalShippingIcon /> },
            { segment: "accounts/detailed-account-statement", title: intl.formatMessage({ id: `header.detailedAccountStatement` }), icon: <DescriptionIcon /> },
            { segment: "accounts/total-account-statement", title: intl.formatMessage({ id: `header.TotalAccountStatement` }), icon: <AssignmentIcon /> },
          ],
        },
        { kind: "divider" },
        { kind: "page", segment: "bills", title: intl.formatMessage({ id: `header.bills` }), icon: <DescriptionIcon /> },
        { kind: "page", segment: "bills/add-bill", title: intl.formatMessage({ id: `header.addBills` }), icon: <AddCircleOutlineIcon /> },
        { kind: "page", segment: "union-bills", title: intl.formatMessage({ id: `header.unionBills` }), icon: <ListAltIcon /> },
        { kind: "page", segment: "accounting-transaction", title: intl.formatMessage({ id: `header.AccountingTransaction` }), icon: <AccountTreeIcon /> },
        {
          kind: "page",
          segment: "open-accounting-transaction",
          title: intl.formatMessage({ id: `header.openAccountingTransaction` }),
          icon: <UnarchiveIcon />,
        },
        { kind: "page", segment: "required-materials", title: intl.formatMessage({ id: `header.RequiredMaterials` }), icon: <Inventory2Icon /> },
        {
          kind: "page",
          segment: "closing-expire-date-item",
          title: intl.formatMessage({ id: `header.ClosingExpireDateItem` }),
          icon: <WarningIcon />,
        },
        { kind: "page", segment: "items-transactions", title: intl.formatMessage({ id: `header.ItemsTransactions` }), icon: <SwapHorizIcon /> },
        { kind: "page", segment: "material-inventory", title: intl.formatMessage({ id: `header.MaterialInventory` }), icon: <Inventory2Icon /> },
        { kind: "page", segment: "profit-report", title: intl.formatMessage({ id: `header.ProfitReport` }), icon: <TrendingUpIcon /> },
        { kind: "page", segment: "openingm-erchandise", title: intl.formatMessage({ id: `header.OpeningMerchandise` }), icon: <UnarchiveIcon /> },
        { kind: "page", segment: "users", title: intl.formatMessage({ id: `header.users` }), icon: <PersonIcon /> },
        { kind: "page", segment: "roles", title: intl.formatMessage({ id: `header.Roles` }), icon: <SecurityIcon /> },
        { kind: "page", segment: "trial-balance", title: intl.formatMessage({ id: `header.TrialBalance` }), icon: <BalanceIcon /> },
        { kind: "page", segment: "final-accounts", title: intl.formatMessage({ id: `header.FinalAccounts` }), icon: <AssessmentIcon /> },
        { kind: "page", segment: "special-materials", title: intl.formatMessage({ id: `header.SpecialMaterials` }), icon: <FolderSpecialIcon /> },
        { kind: "page", segment: "repository", title: intl.formatMessage({ id: `header.repository` }), icon: <StorageIcon /> },
        { kind: "page", segment: "currency", title: intl.formatMessage({ id: `header.currency` }), icon: <CurrencyExchangeIcon /> },
        { kind: "page", segment: "subscription", title: intl.formatMessage({ id: `header.subscription` }), icon: <CardMembershipIcon /> },
        // { kind: "page", segment: "salesmen", title: intl.formatMessage({ id: `header.salesmen` }), icon: <PeopleIcon /> },
      ];

      // إضافة orders-dist-doctor فقط إذا كان المستخدم موزع
      if (isDistributer || isDriver || isSalesman) {
        const ordersDistIndex = navItems.findIndex(item => item.segment === "orders-dist");
        if (ordersDistIndex !== -1) {
          navItems.splice(ordersDistIndex + 1, 0, { kind: "page", segment: "orders-dist-doctor", title: intl.formatMessage({ id: `header.OrdersDistDoctor` }), icon: <LocalHospitalIcon /> });
          // navItems.splice(ordersDistIndex + 1, 0, { kind: "page", segment: "salesmen", title: intl.formatMessage({ id: `header.salesmen` }), icon: <PeopleIcon /> });
        }
      }

      if (isDistributer) {
        const ordersDistIndex = navItems.findIndex(item => item.segment === "orders-dist");
        if (ordersDistIndex !== -1) {
          // navItems.splice(ordersDistIndex + 1, 0, { kind: "page", segment: "orders-dist-doctor", title: intl.formatMessage({ id: `header.OrdersDistDoctor` }), icon: <LocalHospitalIcon /> });
          navItems.splice(ordersDistIndex + 1, 0, { kind: "page", segment: "salesmen", title: intl.formatMessage({ id: `header.salesmen` }), icon: <PeopleIcon /> });
          const salesmenIndex = navItems.findIndex(item => item.segment === "salesmen");
          if (salesmenIndex !== -1) {
            navItems.splice(salesmenIndex + 1, 0, { kind: "page", segment: "distribution-areas", title: intl.formatMessage({ id: `header.distributionAreas` }), icon: <LocationOnIcon /> });
            const distributionAreasIndex = navItems.findIndex(item => item.segment === "distribution-areas");
            if (distributionAreasIndex !== -1) {
              navItems.splice(distributionAreasIndex + 1, 0, { kind: "page", segment: "salesmen-regions", title: intl.formatMessage({ id: `header.salesmenRegions` }), icon: <PeopleIcon /> });
            }
          }
        }
      }

      // إضافة warehouses و warehouse-orders فقط إذا لم يكن المستخدم موزع
      if (!isDistributer && !isDriver && !isSalesman) {
        const pharmacyIndex = navItems.findIndex(item => item.segment === "pharmacy");
        if (pharmacyIndex !== -1) {
          navItems.splice(pharmacyIndex + 1, 0,
            { kind: "page", segment: "warehouses", title: intl.formatMessage({ id: `header.warehouses` }), icon: <WarehouseIcon /> },
            { kind: "page", segment: "warehouse-orders", title: intl.formatMessage({ id: `header.warehouse-orders` }), icon: <ShoppingBagIcon /> }
          );
        }
      }

      return navItems;
    },
    [intl, isDistributer, isDriver, isSalesman]
  );

  // تصفية navigation بناءً على الصلاحيات
  const navigation = React.useMemo(() => {
    return allNavigation
      .map((item) => {
        // إذا كان divider أو header، إرجاعه كما هو
        if (item.kind === "divider" || item.kind === "header") {
          return item;
        }

        // إذا كان page، التحقق من الصلاحية
        if (item.kind === "page") {
          const hasAccess = hasPathPermission(item.segment);
          return hasAccess ? item : null;
        }

        // إذا كان group، تصفية children والتحقق من وجود أطفال بعد التصفية
        if (item.kind === "group" && item.children) {
          const filteredChildren = item.children.filter((child) => {
            // للمسارات المتداخلة مثل accounts/customer يجب استخدام المسار الكامل /accounts/customer
            const fullPath = `/${item.segment}/${child.segment}`;
            return hasPathPermission(fullPath);
          });

          // إذا كان هناك أطفال بعد التصفية، إرجاع المجموعة
          if (filteredChildren.length > 0) {
            return {
              ...item,
              children: filteredChildren,
            };
          }
          // إذا لم يكن هناك أطفال، إخفاء المجموعة
          return null;
        }

        return item;
      })
      .filter(Boolean); // إزالة العناصر null
  }, [allNavigation, hasPathPermission]);

  const quickActions = React.useMemo(() => {
    const actions = [
      {
        id: "add-bill",
        segment: "bills/add-bill",
        label: intl.formatMessage({ id: "quickActions.addBill", defaultMessage: "إضافة فاتورة" }),
        icon: <AddCircleOutlineIcon fontSize="small" />,
      },
      {
        id: "detailed-account-statement",
        segment: "accounts/detailed-account-statement",
        label: intl.formatMessage({ id: "quickActions.detailedAccount", defaultMessage: "كشف حساب تفصيلي" }),
        icon: <DescriptionIcon fontSize="small" />,
      },
      {
        id: "pos",
        segment: "home-page",
        label: intl.formatMessage({ id: "quickActions.pos", defaultMessage: "نقطة بيع" }),
        icon: <PointOfSaleIcon fontSize="small" />,
      },
      {
        id: "orders",
        segment: (isDistributer || isDriver || isSalesman) ? "orders-dist" : "orders",
        label: intl.formatMessage({ id: "quickActions.orders", defaultMessage: (isDistributer || isDriver || isSalesman) ? "طلبات الصيدليات" : "طلبات المرضى" }),
        icon: <ListAltIcon fontSize="small" />,
      },
      {
        id: "warehouses",
        segment: "warehouses",
        label: intl.formatMessage({ id: "quickActions.warehouses", defaultMessage: "المستودعات" }),
        icon: <WarehouseIcon fontSize="small" />,
      },
    ];

    return actions
      .filter((action) => hasPathPermission(action.segment))
      .map((action) => ({
        ...action,
        action: () => {
          navigate(`/${action.segment}`);
          if (!isMdUp) {
            setDrawerOpen(false);
          }
        },
      }));
  }, [intl, hasPathPermission, navigate, isMdUp, isDistributer, isDriver, isSalesman]);

  const flatRoutes = React.useMemo(() => {
    const pages = [];
    navigation.forEach((item) => {
      if (item.kind === "page") {
        pages.push(item);
      } else if (item.kind === "group") {
        item.children?.forEach((child) => pages.push(child));
      }
    });
    return pages;
  }, [navigation]);

  const pageOptions = React.useMemo(
    () =>
      flatRoutes.map((route) => ({
        label: route?.title ?? route?.segment,
        segment: route?.segment,
      })),
    [flatRoutes]
  );

  const handleNotificationClick = (id) => {
    setNotifications((prev) => prev.map((n) => (n.id === id ? { ...n, read: true } : n)));
  };

  const resolveNotificationValues = React.useCallback(
    (values) => {
      if (!values) {
        return undefined;
      }
      const resolvedValues = { ...values };

      if (values.medicineTranslations) {
        resolvedValues.medicine =
          values.medicineTranslations[app.locale] ??
          values.medicineTranslations.en ??
          values.medicineTranslations.ar ??
          values.medicineTranslations.default;
        delete resolvedValues.medicineTranslations;
      }

      if (values.supplierTranslations) {
        resolvedValues.supplier =
          values.supplierTranslations[app.locale] ??
          values.supplierTranslations.en ??
          values.supplierTranslations.ar ??
          values.supplierTranslations.default;
        delete resolvedValues.supplierTranslations;
      }

      return resolvedValues;
    },
    [app.locale]
  );

  const currentPageTitle = UpperCaseFirst(location.pathname.split("/").filter(Boolean).pop() || "home");

  const handleNavigateTo = React.useCallback(
    (segment) => {
      if (!segment) return;
      navigate(`/${segment}`);
      if (!isMdUp) {
        setDrawerOpen(false);
      }
    },
    [navigate, isMdUp]
  );

  const handleSearchSubmit = React.useCallback(() => {
    const term = searchValue.trim().toLowerCase();
    if (!term) return;
    const target = pageOptions.find((route) => route.label?.toLowerCase().includes(term));
    if (target) {
      handleNavigateTo(target.segment);
      setSearchValue("");
    }
  }, [searchValue, pageOptions, handleNavigateTo]);

  const handleAutocompleteChange = (event, newValue) => {
    if (typeof newValue === "string") {
      setSearchValue(newValue);
      return;
    }
    if (newValue?.segment) {
      handleNavigateTo(newValue.segment);
      setSearchValue("");
    }
  };

  const drawer = (
    <Box sx={{ height: "100%", display: "flex", flexDirection: "column" }} dir={app.direction}>
      <Stack spacing={1} sx={{ p: 2 }}>
        <Stack direction="row" spacing={1} alignItems="center">
          <Avatar sx={{ bgcolor: theme.palette.primary.main, width: 40, height: 40 }}>C</Avatar>
          <Box sx={{ flexGrow: 1 }}>
            <Typography variant="subtitle1" fontWeight={700}>
              Cureox
            </Typography>
            {/* <Typography variant="caption" color="text.secondary">
              إدارة صيدلية متقدمة
            </Typography> */}
          </Box>
          <IconButton size="small" onClick={handleDrawerToggle}>
            <CloseIcon fontSize="small" />
          </IconButton>
        </Stack>
        <Divider />
      </Stack>
      <Box sx={{ flex: 1, overflowY: "auto" }}>
        <List>
          {navigation.map((item, index) => {
            if (item.kind === "divider") {
              return <Divider key={`divider-${index}`} sx={{ my: 1.5 }} />;
            }
            if (item.kind === "header") {
              return (
                <Typography key={`header-${index}`} variant="caption" sx={{ px: 3, py: 1, color: "text.secondary", fontWeight: 600, width: "100%" }}>
                  {item.title}
                </Typography>
              );
            }
            if (item.kind === "group") {
              const open = expandedGroups[item.segment] ?? true;
              return (
                <Box key={item.segment}>
                  <ListItemButton onClick={() => handleToggleGroup(item.segment)}>
                    <ListItemIcon sx={{ minWidth: 36 }}>
                      {React.cloneElement(item.icon, { fontSize: "small" })}
                    </ListItemIcon>
                    <ListItemText
                      primary={item.title}
                      primaryTypographyProps={{ fontSize: "0.8125rem" }}
                    />
                    {open ? <ExpandLess fontSize="small" /> : <ExpandMore fontSize="small" />}
                  </ListItemButton>
                  <Collapse in={open} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                      {item.children.map((child) => {
                        const exactPath = `/${child.segment}`;
                        // التحقق من أن المسار يساوي بالضبط المسار أو يبدأ بالمسار متبوعاً بـ /
                        const isActive = location.pathname === exactPath ||
                          (location.pathname.startsWith(`${exactPath}/`) && !location.pathname.startsWith(`${exactPath}-`));
                        return (
                          <ListItemButton
                            key={child.segment}
                            sx={{ pl: 7 }}
                            selected={isActive}
                            onClick={() => {
                              navigate(`/${child.segment}`);
                              if (!isMdUp) setDrawerOpen(false);
                            }}
                          >
                            <ListItemIcon sx={{ minWidth: 28 }}>
                              {React.cloneElement(child.icon, { fontSize: "small" })}
                            </ListItemIcon>
                            <ListItemText
                              primary={child.title}
                              primaryTypographyProps={{ fontSize: "0.8125rem" }}
                            />
                          </ListItemButton>
                        );
                      })}
                    </List>
                  </Collapse>
                </Box>
              );
            }
            const exactPath = `/${item.segment}`;
            // التحقق من أن المسار يساوي بالضبط المسار أو يبدأ بالمسار متبوعاً بـ /
            // تجنب مطابقة `/home-page` مع `/home`
            const isActive = location.pathname === exactPath ||
              (location.pathname.startsWith(`${exactPath}/`) && !location.pathname.startsWith(`${exactPath}-`));
            return (
              <ListItemButton
                key={item.segment}
                selected={isActive}
                onClick={() => {
                  navigate(`/${item.segment}`);
                  if (!isMdUp) setDrawerOpen(false);
                }}
              >
                <ListItemIcon sx={{ minWidth: 36 }}>
                  {React.cloneElement(item.icon, { fontSize: "small", color: isActive ? "primary" : "text.secondary" })}
                </ListItemIcon>
                <ListItemText
                  primary={item.title}
                  primaryTypographyProps={{ fontSize: "0.8125rem" }}
                />
                {isActive && (app.direction === "rtl" ? <ChevronLeftIcon fontSize="small" /> : <ChevronRightIcon fontSize="small" />)}
              </ListItemButton>
            );
          })}
        </List>
      </Box>
      <Box sx={{ p: 2 }}>
        <Paper
          variant="outlined"
          sx={{ p: 2, borderRadius: 3, bgcolor: alpha(theme.palette.primary.main, 0.04), borderColor: alpha(theme.palette.primary.main, 0.2) }}
        >
          <Stack spacing={1}>
            <Typography variant="body2" color="text.secondary">
              {intl.formatMessage({ id: "layout.drawer.currentStatus", defaultMessage: "الوضع الحالي" })}
            </Typography>
            <Chip
              icon={<HomeRoundedIcon />}
              label={intl.formatMessage({ id: "layout.drawer.dashboardLabel", defaultMessage: "لوحة القيادة" })}
              color="primary"
              size="small"
            />
            <Button
              startIcon={<TranslateIcon />}
              variant="text"
              onClick={() => handleLanguage(app.locale === "ar" ? "en" : "ar", app.locale === "ar" ? "ltr" : "rtl")}
            >
              {app.locale === "ar"
                ? intl.formatMessage({ id: "layout.language.english", defaultMessage: "English" })
                : intl.formatMessage({ id: "layout.language.arabic", defaultMessage: "العربية" })}
            </Button>
          </Stack>
        </Paper>
      </Box>
    </Box>
  );

  // تطبيق zoom على html element لمحاكاة zoom المتصفح الفعلي (Ctrl+ و Ctrl-)
  React.useEffect(() => {
    const zoomValue = (app.zoom || 100) / 100;

    // استخدام zoom على html element لمحاكاة zoom المتصفح الفعلي
    // هذا يحاكي سلوك Ctrl+ و Ctrl- في المتصفح بشكل أفضل
    const htmlElement = document.documentElement;
    htmlElement.style.zoom = zoomValue;

    // ضبط body لضمان عدم وجود فراغات
    document.body.style.width = "100%";
    document.body.style.overflowX = "hidden";

    return () => {
      htmlElement.style.zoom = "";
      document.body.style.width = "";
      document.body.style.overflowX = "";
    };
  }, [app.zoom]);

  return (
    <Box
      sx={theme => ({
        display: "flex",
        flexDirection: app.direction === "rtl" ? "row" : "row",
        minHeight: "100vh",
        bgcolor: "background.default",
        width: "100%",
        maxWidth: "100vw",
        overflowX: "hidden",
        boxSizing: "border-box",
        fontFamily: theme.fontFamily,
      })}
      dir={app.direction}
    >
      <AppBar
        position="fixed"
        color="inherit"
        elevation={0}
        dir={app.direction}
        sx={{
          borderBottom: `1px solid ${alpha(theme.palette.divider, 0.7)}`,
          backgroundColor: theme.palette.background.paper,
          width: {
            xs: "100%",
            md: `calc(100% - ${drawerOpen ? drawerWidth : 0}px)`,
          },
          marginLeft: {
            md: drawerOpen ? `${drawerWidth}px` : 0,
          },
          marginRight: 0,
          left: 0,
          right: "auto",
          transition: "margin 0.2s ease, width 0.2s ease",
          pl: 1,
          pr: 1,
        }}
      >
        <Toolbar
          sx={{
            display: "flex",
            width: "100%",
            justifyContent: "space-between",
            flexDirection: app.direction === "rtl" ? "row" : "row",
            gap: 2,
            p: '0 !important',
            m: '0 !important',
          }}
        >
          <Stack direction="row" alignItems="center" spacing={1}>
            <IconButton color="primary" onClick={handleDrawerToggle}>
              {/* {drawerOpen ? <CloseIcon /> : <MenuIcon />} */}
              {drawerOpen ? null : <MenuIcon />}
            </IconButton>
            <Stack spacing={0.25}>
              {/* <Typography variant="subtitle1" fontWeight={700}>
                Cureox
              </Typography> */}
              <SubHeader />
              {/* <Typography variant="caption" color="text.secondary">
                إدارة العمليات اليومية بكل سهولة
              </Typography> */}
            </Stack>
          </Stack>

          <SearchWrapper
            dir={app.direction}
            onSubmit={(e) => {
              e.preventDefault();
              handleSearchSubmit();
            }}
          >
            <Autocomplete
              freeSolo
              size="small"
              options={pageOptions}
              inputValue={searchValue}
              onInputChange={(event, newInputValue, reason) => {
                if (reason === "input" || reason === "clear") {
                  setSearchValue(newInputValue);
                }
              }}
              onChange={handleAutocompleteChange}
              getOptionLabel={(option) => (typeof option === "string" ? option : option?.label ?? "")}
              sx={{ flex: 1 }}
              dir={app.direction}
              noOptionsText={intl.formatMessage({
                id: "layout.searchNoResults",
                defaultMessage: "لا توجد نتائج",
              })}
              ListboxProps={{
                dir: app.direction,
                style: { textAlign: app.direction === "rtl" ? "right" : "left" }
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  dir={app.direction}
                  placeholder={intl.formatMessage({
                    id: "layout.searchPlaceholder",
                    defaultMessage: "ابحث عن صفحة أو تقرير",
                  })}
                  variant="standard"
                  InputProps={{
                    ...params.InputProps,
                    disableUnderline: true,
                    startAdornment: (
                      <>
                        <SearchIcon
                          fontSize="small"
                          sx={{
                            color: "text.secondary",
                            [app.direction === "rtl" ? "mr" : "ml"]: 1
                          }}
                        />
                        {params.InputProps.startAdornment}
                      </>
                    ),
                  }}
                />
              )}
            />
          </SearchWrapper>

          <Stack
            direction="row"
            spacing={1}
            sx={{
              // ml: app.direction !== "rtl" ? 0 : "auto",
              // mr: app.direction !== "rtl" ? "auto" : 0,
            }}
            alignItems="center"
          >
            {quickActions.map((action) => (
              <Tooltip key={action.id} title={action.label} placement="bottom">
                <IconButton
                  color="primary"
                  size="small"
                  onClick={action.action}
                  sx={{
                    bgcolor: alpha(theme.palette.primary.main, 0.08),
                    "&:hover": { bgcolor: alpha(theme.palette.primary.main, 0.16) },
                  }}
                >
                  {action.icon}
                </IconButton>
              </Tooltip>
            ))}
            <Tooltip title={intl.formatMessage({ id: "header.zoomOut", defaultMessage: "تصغير" })} placement="bottom">
              <IconButton
                color="primary"
                size="small"
                onClick={handleZoomOut}
                disabled={app.zoom <= 70}
                sx={{
                  bgcolor: alpha(theme.palette.primary.main, 0.08),
                  "&:hover": { bgcolor: alpha(theme.palette.primary.main, 0.16) },
                  "&.Mui-disabled": { opacity: 0.5 },
                }}
              >
                <ZoomOutIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title={intl.formatMessage({ id: "header.zoomIn", defaultMessage: "تكبير" })} placement="bottom">
              <IconButton
                color="primary"
                size="small"
                onClick={handleZoomIn}
                disabled={app.zoom >= 140}
                sx={{
                  bgcolor: alpha(theme.palette.primary.main, 0.08),
                  "&:hover": { bgcolor: alpha(theme.palette.primary.main, 0.16) },
                  "&.Mui-disabled": { opacity: 0.5 },
                }}
              >
                <ZoomInIcon />
              </IconButton>
            </Tooltip>
            <IconButton color="primary" onClick={(e) => setNotifAnchorEl(e.currentTarget)}>
              <Badge badgeContent={unreadCount} color="error">
                <NotificationsIcon />
              </Badge>
            </IconButton>
            <IconButton color="secondary" onClick={(e) => setProfileAnchorEl(e.currentTarget)}>
              <Avatar sx={{ width: 36, height: 36, bgcolor: theme.palette.primary.main }}>
                {user?.user_name?.slice(0, 2)?.toUpperCase() ?? "U"}
              </Avatar>
            </IconButton>
          </Stack>
        </Toolbar>
      </AppBar>

      <Box
        component="nav"
        sx={{
          width: { md: drawerOpen ? drawerWidth : 0 },
          flexShrink: { md: 0 },
          transition: "width 0.2s ease",
        }}
        aria-label="sidebar navigation"
      >
        <Drawer
          variant={isMdUp ? "persistent" : "temporary"}
          open={drawerOpen}
          onClose={handleDrawerToggle}
          ModalProps={{ keepMounted: true }}
          anchor="left"
          sx={{
            "& .MuiDrawer-paper": {
              width: drawerWidth,
              borderRight: `1px solid ${theme.palette.divider}`,
              borderLeft: "none",
              direction: app.direction,
              textAlign: app.direction === "rtl" ? "right" : "left",
              boxSizing: "border-box",
            },
          }}
        >
          {drawer}
        </Drawer>
      </Box>

      <Box
        component="main"
        // maxWidth="x5l"
        sx={{
          flexGrow: 1,
          p: { ss: 1.8, md: 1.8 },
          mt: { ss: "72px", md: "50px" },
          width: "100%",
          flexBasis: "100%",
          maxWidth: "100%",
          overflowX: "hidden",
          overflowY: "auto",
          boxSizing: "border-box",
          // ml: {
          //   md: drawerOpen ? `${drawerWidth}px` : 0,
          // },
          // mr: 0,
          transition: "margin 0.2s ease, padding 0.2s ease",
        }}
      >
        <Stack spacing={2.5} sx={{ width: "100%", maxWidth: "100%", overflowX: "hidden", boxSizing: "border-box" }}>
          {/* <SubHeader /> */}
          <Box sx={{ width: "100%", maxWidth: "100%", overflowX: "hidden", boxSizing: "border-box", pt: 1, mt: '0px !important' }}>{children}</Box>
        </Stack>
      </Box>

      <Menu
        anchorEl={notifAnchorEl}
        open={Boolean(notifAnchorEl)}
        onClose={() => setNotifAnchorEl(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        PaperProps={{ sx: { minWidth: 320 } }}
      >
        <MenuItem disableRipple divider sx={{ pointerEvents: "none" }}>
          <Stack direction="row" alignItems="center" spacing={1}>
            <Typography fontWeight={600}>
              {`${intl.formatMessage({
                id: "layout.notifications.heading",
                defaultMessage: "الإشعارات",
              })} (${notifications.length})`}
            </Typography>
            <Chip
              size="small"
              label={intl.formatMessage(
                {
                  id: "layout.notifications.unreadCount",
                  defaultMessage: "{count} غير مقروء",
                },
                { count: unreadCount }
              )}
              color="primary"
            />
          </Stack>
          <Box sx={{ flexGrow: 1 }} />
          {unreadCount > 0 && (
            <Button
              size="small"
              onClick={() => setNotifications((prev) => prev.map((n) => ({ ...n, read: true })))}
            >
              {intl.formatMessage({ id: "layout.notifications.markAll", defaultMessage: "تحديد الكل" })}
            </Button>
          )}
        </MenuItem>
        {notifications.map((n) => {
          const localizedValues = resolveNotificationValues(n.bodyValues);
          return (
            <MenuItem
              key={n.id}
              onClick={() => handleNotificationClick(n.id)}
              sx={{
                alignItems: "flex-start",
                gap: 1,
                bgcolor: n.read ? "transparent" : alpha(theme.palette.primary.main, 0.08),
              }}
            >
              <Badge variant="dot" color="primary" overlap="circular" invisible={n.read}>
                <NotificationsIcon fontSize="small" />
              </Badge>
              <Box>
                <Typography fontWeight={n.read ? 500 : 700}>
                  {intl.formatMessage({ id: n.titleMessageId })}
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  {intl.formatMessage({ id: n.bodyMessageId }, localizedValues)} •{" "}
                  {intl.formatMessage({ id: n.timeMessageId })}
                </Typography>
              </Box>
            </MenuItem>
          );
        })}
      </Menu>

      <Menu
        anchorEl={profileAnchorEl}
        open={Boolean(profileAnchorEl)}
        onClose={() => setProfileAnchorEl(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <MenuItem disabled>
          <Stack spacing={0.5}>
            <Typography fontWeight={600}>
              {user?.user_name ??
                intl.formatMessage({ id: "layout.profile.defaultUser", defaultMessage: "المستخدم" })}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              {user?.name ??
                intl.formatMessage({ id: "layout.profile.defaultAccount", defaultMessage: "حسابك الشخصي" })}
            </Typography>
          </Stack>
        </MenuItem>
        <Divider />
        <MenuItem onClick={() => handleLanguage("ar", "rtl")}>
          <ListItemIcon>
            <TranslateIcon fontSize="small" />
          </ListItemIcon>
          {intl.formatMessage({ id: "layout.language.arabic", defaultMessage: "العربية" })}
        </MenuItem>
        <MenuItem onClick={() => handleLanguage("en", "ltr")}>
          <ListItemIcon>
            <TranslateIcon fontSize="small" />
          </ListItemIcon>
          {intl.formatMessage({ id: "layout.language.english", defaultMessage: "English" })}
        </MenuItem>
        <MenuItem onClick={handleLogout}>
          <ListItemIcon>
            <LogoutIcon fontSize="small" />
          </ListItemIcon>
          <FormattedMessage id="logout" defaultMessage="تسجيل خروج" />
        </MenuItem>
        <MenuItem onClick={() => setProfileAnchorEl(null)}>
          <ListItemIcon>
            <SettingsIcon fontSize="small" />
          </ListItemIcon>
          <FormattedMessage id="settings" defaultMessage="الإعدادات" />
        </MenuItem>
      </Menu>
    </Box>
  );
};

export default Layout;
































// -------------------
// -------------------
// -------------------
// -------------------
// -------------------
// -------------------
// -------------------
// -------------------
// -------------------
// -------------------
// -------------------
// -------------------
